import { render, staticRenderFns } from "./Resultdownload.vue?vue&type=template&id=fc1c34a4&scoped=true&"
import script from "./Resultdownload.vue?vue&type=script&lang=js&"
export * from "./Resultdownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1c34a4",
  null
  
)

export default component.exports